"use client";

import type { RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

import { commonFormFields } from "@/libs/builder/common/formFields";
import { withValidation } from "@/libs/builder/validators/validateBuilderComponentData";

export const loyaltyContactFormTextAreaInputs = [
  ...commonFormFields,
  {
    name: "required",
    type: "boolean",
    required: true,
    defaultValue: false,
  },
  {
    name: "validationErrorMessage",
    type: "string",
    defaultValue: "This field is required",
  },
] as const satisfies Inputs;

export const LoyaltyContactFormTextAreaComponent: RegisteredComponent = {
  name: "LoyaltyContactFormTextArea",
  component: dynamic(async () =>
    withValidation(
      loyaltyContactFormTextAreaInputs,
      (await import("./LoyaltyContactFormTextArea")).LoyaltyContactFormTextArea,
      "LoyaltyContactFormTextArea"
    )
  ),
  inputs: loyaltyContactFormTextAreaInputs,
  noWrap: true,
};
